/**
 * Surface-elevation seam.
 *
 * Everything that needs to know "how high is the ground here?" — gear/ground
 * contact in the flight model, and the render ground-plane height — goes through
 * this one interface. Today the only implementation is a flat plane at a fixed
 * MSL elevation (per airport), which reproduces the original hardcoded "ground
 * at MSL 0" behaviour exactly when the elevation is 0.
 *
 * This is the single hook for a future basic elevation model: a heightmap/DEM
 * sampler implementing the same `elevationAt(n, e)` drops in with no changes to
 * the physics or the coordinate frame (Three world-Y already equals MSL metres,
 * so a mesh built in MSL stays consistent with the flight model).
 */
export interface TerrainProvider {
  /** Ground surface height (metres MSL) at a local NED horizontal point. */
  elevationAt(n: number, e: number): number;
}

/** Flat ground at a single MSL elevation — the current (pre-terrain) behaviour. */
export class FlatTerrain implements TerrainProvider {
  constructor(private readonly elevation: number) {}
  elevationAt(): number {
    return this.elevation;
  }
}
